import { ExportColumnOptions } from '../types';
import resolveNonNegativeInteger from './resolveNonNegativeInteger';
import resolveNumberValue from './resolveNumberValue';

const resolveRoundedValue = (
  value: unknown,
  exportOptions: ExportColumnOptions
): unknown => {
  if (exportOptions.roundingMode === 'none') {
    return value;
  }

  const decimalPlaces = resolveNonNegativeInteger(exportOptions.decimalPlaces);

  if (decimalPlaces === undefined) {
    return value;
  }

  const numericValue = resolveNumberValue(value);

  if (numericValue === undefined) {
    return value;
  }

  const factor = 10 ** decimalPlaces;
  const scaledValue = numericValue * factor;

  // 10 ** decimalPlaces overflows past 308, turning the scale/round/unscale trip into NaN.
  if (!Number.isFinite(scaledValue)) {
    return value;
  }

  switch (exportOptions.roundingMode) {
    case 'up':
      return Math.ceil(scaledValue) / factor;
    case 'down':
      return Math.floor(scaledValue) / factor;
    case 'math':
      return Math.round(scaledValue) / factor;
    default:
      return value;
  }
};

export default resolveRoundedValue;
